import { createPublicClient } from "@vimos/api-client";

export const supabase = createPublicClient({
  url: import.meta.env.VITE_SUPABASE_URL,
  anonKey: import.meta.env.VITE_SUPABASE_ANON_KEY,
});
